import React from 'react';
import crypto from 'crypto';
import AppRoutes from '../views/config/AppRoutes';
import { browserHistory } from 'react-router';
import App_data from '../views/config/App_data';
import FD from '../views/RestAPI/fetchData';
import ReactHtmlParser from 'react-html-parser';
import { localStorageKeys, QUESTION_MODE, specialChars } from './constant';

export const _getProfile = (username) => {
  browserHistory.push({ pathname: AppRoutes.PROFILE_ROUTE.replace(':username', username) });
};

export const getRequestAPIData = (dataObj) => {
  const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
  return {
    idname: storage_session['idname'],
    token: storage_session['token'],
    ...dataObj,
  };
};

export const postApiCalling = (route, endpoint, data) =>
  FD.callAPI(`${App_data.backend_api}${route}${endpoint}`, getRequestAPIData(data));
export const indexOfUsingBinarySearch = (arr, target) => {
  let left = 0;
  let right = arr.length - 1;

  while (left <= right) {
    const mid = Math.floor((left + right) / 2);

    if (arr[mid] === target) {
      return mid; // Element found, return its index.
    } else if (arr[mid] < target) {
      left = mid + 1; // Adjust the left bound.
    } else {
      right = mid - 1; // Adjust the right bound.
    }
  }

  return -1; // Element not found in the array.
};

export const downloadPDF = async (bufferData, filename) => {
  const url = window.URL.createObjectURL(new Blob([new Uint8Array(bufferData).buffer]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename || `FileName.pdf`);

  // Append to html link element page
  document.body.appendChild(link);

  // Start download
  link.click();

  // Clean up and remove the link
  link.parentNode.removeChild(link);
};

export const openPDF = async (resp) => {
  const openPDFWindow = window.open(resp.data.pdf);
  // openPDFWindow = null; //   // this.downloadFile(resp.data.pdf);
  if (openPDFWindow === null || typeof openPDFWindow === 'undefined') {
    const response = await FD.callAPI(`${App_data.backend_api}/s3-pdf-buffer-data`, {
      bucket: resp.data.s3BucketName,
      key: resp.data.s3Key,
    });
    if (response.success) {
      downloadPDF(response.Body.data, response.filename);
    }
  }
};

export const generateDynamicRoute = (route, data, chapterName) => {
  const { pathname, keys } = route;

  if (!keys || !Array.isArray(keys)) {
    return pathname;
  }

  return keys.reduce((updatedPathname, { key, apiKey }) => {
    const replacementValue = data[apiKey] || '';
    return updatedPathname.replace(
      `:${key}`,
      key === 'chapter_name' && chapterName ? chapterName : replacementValue,
    );
  }, pathname);
};

const updateExamPackagesWithSpecialPrices = (examPackages, specialPrices) => {
  if (!specialPrices || typeof specialPrices !== 'object') {
    return examPackages;
  }

  return examPackages.map((packageDetail) => {
    const updatedPrice = specialPrices[packageDetail.id];
    return {
      ...packageDetail,
      price: updatedPrice ? parseFloat(updatedPrice) : packageDetail.price,
    };
  });
};

export const retrieveSpecialPrice = async (partnerId, plans) => {
  // Check if plans are empty or not provided
  if (!plans || plans.length === 0) {
    return []; // Return an empty array or handle as needed
  }

  try {
    const adminDetails = await FD.callAPI(`${App_data.backend_api}/user/admin`, { partnerId });

    if (!adminDetails || !adminDetails.partnerDetails) {
      return plans;
    }

    const specialPrice = adminDetails.partnerDetails.special_prices
      ? JSON.parse(adminDetails.partnerDetails.special_prices)
      : {};

    return updateExamPackagesWithSpecialPrices(plans, specialPrice);
  } catch (error) {
    return plans;
  }
};
/**
 * Removes '– Volume X' (case-insensitive) from a title string.
 * Works for the en dash ('–') followed by 'VOLUME' and a number,
 * and keeps the rest of the title intact.
 */
export function removeSuffix(title, keyword = '– volume') {
  if (!title || !keyword) return title;

  const normalizedTitle = title.toLowerCase();
  const normalizedKeyword = keyword.toLowerCase();

  const keywordIndex = normalizedTitle.indexOf(normalizedKeyword);
  if (keywordIndex === -1) return title;

  const baseTitle = title.substring(0, keywordIndex).trim();

  let nextIndex = keywordIndex + normalizedKeyword.length;

  // Skip any spaces and numbers following the keyword
  while (nextIndex < title.length && (title[nextIndex] === ' ' || /\d/.test(title[nextIndex]))) {
    nextIndex++;
  }

  const remainingText = title.slice(nextIndex).trimStart();

  return remainingText ? `${baseTitle} ${remainingText}` : baseTitle;
}

// Turn a section header label (e.g. "Live Sessions") into a DOM-safe
// anchor id ("recorded-webinars") used for in-page category navigation.
export function slugifyHeader(title) {
  if (!title) return '';
  return String(title)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export const renderHTMLContent = (html, tag = 'span', className = '', extraProps = {}) => {
  const Tag = tag;
  return <Tag className={className} dangerouslySetInnerHTML={{ __html: html }} {...extraProps} />;
};

export const renderSanitizedHTML = (html) => ReactHtmlParser(html);

export const generateRandomInteger = (min, max) => {
  const range = max - min;
  if (range <= 0) throw new Error('Invalid range');

  const randomBytes = crypto.randomBytes(4);
  const randomNumber = randomBytes.readUInt32BE(0) / 0xffffffff;

  return Math.floor(randomNumber * range + min);
};

export const formatTime = (seconds) => {
  if (seconds < 60) {
    return `${seconds}sec`;
  } else {
    const getminutes = Math.trunc(seconds / 60);
    const getSeconds = Math.trunc(seconds % 60);
    return `${getminutes}min ${getSeconds}sec`;
  }
};

export const onHandleTableSorting = (value) => {
  const index = value;
  const table = document.getElementById('bodyData');
  if (!table) return;

  let switching = true;

  const sanitizeValue = (cell) => {
    let val = parseFloat(cell.innerHTML.replace(/[><]/g, '').replace(/&[gl]t;/g, ''));
    if (isNaN(val)) {
      val = cell.innerHTML.toLowerCase().trim();
      val = specialChars.test(val) ? '0' : val;
    }
    return val;
  };

  while (switching) {
    switching = false;
    const rows = table.rows;

    for (let i = 0; i < rows.length - 1; i++) {
      const x = rows[i].cells[index];
      const y = rows[i + 1].cells[index];
      if (!x || !y) continue;

      let valX = sanitizeValue(x);
      let valY = sanitizeValue(y);

      // Type consistency fallback
      if (isNaN(valX) !== isNaN(valY)) {
        valX = isNaN(valX) ? 0 : valX;
        valY = isNaN(valY) ? 0 : valY;
      }

      let shouldSwitch = false;

      if (valX === valY) {
        const htmlX = x.innerHTML.toLowerCase();
        const htmlY = y.innerHTML.toLowerCase();
        if (htmlX.includes('&gt;') && !htmlY.includes('&gt;')) shouldSwitch = true;
        if (!htmlX.includes('&lt;') && htmlY.includes('&lt;')) shouldSwitch = true;
      } else if (valX > valY) {
        shouldSwitch = true;
      }

      if (shouldSwitch) {
        rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
        switching = true;
        break;
      }
    }
  }
};

export const getQuestionModeFromLocalStorage = (examNameKey) => {
  if (!examNameKey) return;
  const localStorageValue = localStorage.getItem(localStorageKeys.questionMode);
  if (!localStorageValue) return;
  const questionMode = JSON.parse(localStorageValue);
  if (questionMode && typeof questionMode === 'object') {
    return questionMode[examNameKey];
  }
  return;
};

// Utility to set question mode for a given exam in localStorage
export const setQuestionModeToLocalStorage = (examNameKey, mode) => {
  if (!examNameKey) return;
  let questionMode = {};
  const localStorageValue = localStorage.getItem(localStorageKeys.questionMode);
  if (localStorageValue) {
    const parsed = JSON.parse(localStorageValue);
    if (parsed && typeof parsed === 'object') {
      questionMode = parsed;
    }
  }
  questionMode[examNameKey] = mode;
  localStorage.setItem(localStorageKeys.questionMode, JSON.stringify(questionMode));
};

/**
 * Checks if the current mode is revision_mode for a given exam key.
 * @param {string} examNameKey - The key for the exam (e.g., "cfa_1", "gmat_focus").
 * @returns {boolean} - true if revision_mode, false otherwise (defaults to practice_mode).
 */
export const isRevisionModeActive = (examNameKey) => {
  const mode = getQuestionModeFromLocalStorage(examNameKey);
  return mode === QUESTION_MODE.REVISION;
};

export function countStatements(question = {}) {
  return Object.keys(question).filter(
    (key) => key.startsWith('statement') && question[key]
  ).length;
}


// WEBPACK FOOTER //
// ./src/common/function.js